import React, { useMemo } from "react";

import { H2, Message, MessageVariants, P } from "@nel-ui/react";

import { MESSAGE_HEADING_TYPE, MESSAGE_TYPE } from "../../constants";
import { IHeaderProps } from "../../interfaces";
import "./style.css";

const mainClass = "header";
const Header: React.FC<IHeaderProps> = (props: IHeaderProps) => {
  const { heading, subHeading, infoMessage } = props;

  const headerContent = useMemo(() => {
    return (
      <>
        <H2 className={`${mainClass}__heading`} data-testid={mainClass}>
          {heading}
        </H2>
        <P>{subHeading}</P>
        {infoMessage && (
          <Message
            data-ref={MESSAGE_TYPE.INFO}
            heading={MESSAGE_HEADING_TYPE.INFORMATION}
            headingId={MESSAGE_TYPE.INFO}
            variant={MessageVariants.INFO}
            headingLevel={3}
            data-testid={`${mainClass}-info-message`}
          >
            <P>{infoMessage}</P>
          </Message>
        )}
      </>
    );
  }, [heading, subHeading, infoMessage]);

  return headerContent;
};

export default Header;
